import { GearProxyService, GearAppService } from 'common-gear';
import { AppService, CoreTypes, FormParametersComponent, SidebarContainerService, SharedCommonService, CoreProxyService } from 'common-cloudstudio';
import { Component, OnInit, OnDestroy, AfterContentInit, AfterViewInit, ViewChild, OnChanges, HostListener, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Subscription, Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

declare var environment: any;

@Component({
  selector: 'app-devices',
  templateUrl: './devices.component.html',
  styleUrls: ['./devices.component.scss']
})
export class DevicesComponent implements OnInit, AfterContentInit, AfterViewInit, OnDestroy {
  @ViewChild('dropdown') dropdown;
  @ViewChild('formParam') formParam: FormParametersComponent;

  _url: SafeResourceUrl;
  cities = [];
  _facilityID: number;
  _paramSelected: CoreTypes.FormParameter = new CoreTypes.FormParameter();
  clustersFullList: Array<any> = [];
  formParameterList: CoreTypes.FormParameter[];
  formParameterApplied: CoreTypes.FormParameter[] = [];

  _subscription: Subscription;

  _dropdownConfig: { open: string; x: number; y: number; target: HTMLElement } = { open: '', x: 0, y: 0, target: null };
  actions = null;

  executionNumber: number = 0;

  private _intervalDataPackages = 10;
  private _sequenceNumber = 0;
  // To set Timeout
  private timer: any;
  private searchTimeOut: any;
  isCollapsed = true;
  dateLasUpdate: Date = null;
  subscriptions: Subscription[] = [];
  tokenDevice: string = '';
  loading: boolean;
  showTailSpinner: boolean = false;
  showIcon:number = 0;
  openCollapse: boolean = false;
  changeFacility: boolean = false;
  enableFilter: boolean = true;
  _filter: string = '';
  filteredClusters: any[] = [];
  isSearching: boolean = false;

  constructor(
    public _appService: AppService,
    private _gearProxyService: GearProxyService,
    private _gearService: GearAppService,
    private _sharedCommonService: SharedCommonService,
    private _activatedRoute: ActivatedRoute,
    private _coreProxyService: CoreProxyService
  ) {
    this._activatedRoute.queryParams.subscribe(params => {
      if (params['parametersToken']) {
        this.tokenDevice = params['parametersToken']
        this.getParametersFromToken(this.tokenDevice);
      }
    });
  }

  ngOnInit() {
    this.unsubscribeAll();
    environment.openCollapse !== undefined ? this.openCollapse = environment.openCollapse : this.openCollapse = true;
    this._facilityID = this._appService.getFacilityID();
    this.subscriptions.push(this._gearService.onChangeFacilityID.subscribe(facilityID => {
      if (this._facilityID === facilityID) { return; }
      this._facilityID = this._appService.getFacilityID();
      this.clustersFullList = [];
      this.filteredClusters = [];
      this.dateLasUpdate = null;
      this.formParameterApplied = null;
      this.showTailSpinner = false;
      this._filter = '';
      this.loading = true;
      this.showIcon = 0;
      this.isSearching = false;
      this.getData();
      this.appendModal();
    }));
    this.subscriptions.push(this._appService.onFacilitySet.subscribe(() => {
      if (this._facilityID && this._facilityID !== this._appService.getFacilityID()) { this.changeFacility = true; }
    }));

    this.subscriptions.push(this._sharedCommonService.onRefreshFormParameter.subscribe(() => {
      this.enableFilter = false;
      this.onInputFilter();
    }));

    this.subscriptions.push(this._sharedCommonService.onConfirmOperationChangeValue.subscribe(data => {
      this.dropdown.hide();
    }));

    this.subscriptions.push(this._appService.onToggleButtonState.subscribe(state => {
      this.ChangeRefreshParameters(state);
    }))

  }

  ngOnDestroy(){
    this._intervalDataPackages = 0;
    this.unsubscribeAll();
  }

  unsubscribeAll() {
    if(this.timer) { clearTimeout(this.timer); }
    this.timer = null;

    if(this._subscription) { this._subscription.unsubscribe(); }

    this.subscriptions.forEach(s => s.unsubscribe());
  }

  ngAfterContentInit() {}

  ngAfterViewInit() {
    this.getData();
    this.appendModal();
  }

  
  getData(refreshOnChange?: boolean){
    if( ! this._appService.getFacilityID()) {
      this.timer = setTimeout(()=> this.getData(), 1000);
      return;
    }
    if(this.tokenDevice) { return; }


    // ToDo: Agregar funcionalidad para "refresh" de form parameters
    this._gearProxyService.RealTimeDataService.GetDisplayClusterParameters(
      this._appService.getAccessToken(),
      this._appService.getFacilityID(),
      this.formParameterApplied,
      res => {
        this.formParameterList = [];
        res.forEach(item => {
          item.RefreshOnChange = true;
          this.formParameterList.push(item);
        });

        this.formParameterApplied = JSON.parse(JSON.stringify(this.formParameterList));
        setTimeout(() => {
          this.enableFilter = true;
          
        }, 100);
        if(!refreshOnChange) {
          this.getRecursively();
        }
      },
      err => {
        this.enableFilter = true;
        this._appService.showException(err);
      }
    )
  }

  getRecursively() {
    if(this._subscription) { this._subscription.unsubscribe(); }
    this.loading = true;
    this.showIcon = 0;
    if(this.changeFacility && this._sequenceNumber !== 0) {
      this._sequenceNumber = 0;
    }
    this._subscription = this.getDataPackages().subscribe(data => {
      this.changeFacility = false;
      this.sortCollapseItems(this.clustersFullList, 'devices');
      this.sortCollapseItems(this.clustersFullList, 'endpoints');
      this.getRecursively();
      this.applyTextFilter(); 
      this.loading = false;
      this.showIcon = 1;
    }, (error) => {
      this._intervalDataPackages = error;
      this.timer = setTimeout(()=> this.getRecursively(), this._intervalDataPackages);
    })
  }

  getDataPackages(): Observable<any> {
    this.executionNumber++;
    let executionNumber: number = this.executionNumber;

    if (!this.formParameterApplied){
      // Si el cliente/facility se modifica, se borra formParameterApplied lo cual hace que no se pueda consumir GetDisplayClusterDataPacket hasta que se cargue dicha variable
      return new Observable();
    }

    /**
     * Si pasaron mas de 60 segundos desde la último refresco general,
     * mandar el sequence number en 0 para que refresque toda la lista
     */
    if (this.dateLasUpdate === null) { this.dateLasUpdate = new Date(); }
    if (Math.abs(new Date().getTime() - this.dateLasUpdate.getTime()) >= 60000) {
      this._sequenceNumber = 0;
      this.dateLasUpdate = new Date();
    }

    return new Observable(observer => {
      this._gearProxyService.RealTimeDataService.GetDisplayClusterDataPacket(
        this._appService.getAccessToken(),
        this._appService.getFacilityID(),
        this._sequenceNumber,
        150,
        this.formParameterApplied,
        success => {
          try {
            this._sequenceNumber = success.HightestSequenceNumber;
            if (!success.Clusters || success.Clusters.length <= 1) {
              this.showTailSpinner = false;
            } else {
              if (!this.isSearching) {
                this.showTailSpinner = true;
              }
            }
            
            // Controlar que el request que se está ejecutando en este success sea el ultimo ejecutado por el programa
            if(executionNumber !== this.executionNumber) {
              observer.next();
              return;
            }

            // Check all received clusters
            // compare against the list already have
            for (let i = 0; i < success.Clusters.length; i++) {
              let encontrado = -1;
              for (let x = 0; x < this.clustersFullList.length; x++) {
                if (
                  success.Clusters[i]
                  && this.clustersFullList[x]
                  && success.Clusters[i].ClusterID === this.clustersFullList[x].ClusterID
                ) {
                  encontrado = x;
                }
              }

              // If the cluster exist in my list, check every row, if not,
              // it will be added
              if (encontrado > -1) {
                for (let xx = 0; xx < success.Clusters[i].Elements.length; xx++) {
                  let rowEncontrada = -1;
                  for (let y = 0; y < this.clustersFullList[encontrado].Elements.length; y++) {
                    if (
                      success.Clusters[i].Elements[xx]
                      && this.clustersFullList[encontrado].Elements[y]
                      && success.Clusters[i].Elements[xx].ElementID === this.clustersFullList[encontrado].Elements[y].ElementID
                    ) {
                      rowEncontrada = y;
                      break;
                    }
                  }

                  if (rowEncontrada > -1) {
                    this.clustersFullList[encontrado].Elements[rowEncontrada] = success.Clusters[i].Elements[xx];
                  } else {
                    this.clustersFullList[encontrado].Elements.push(success.Clusters[i].Elements[xx]);
                  }
                }
              } else {
                this.clustersFullList.push(success.Clusters[i]);
                this.loading = false;
                this.showIcon = 1;
              }
            }
            observer.next();
          } catch (error) {
            observer.error(5000);
          }
        },
        err => {
          this._appService.showException(err);
          observer.error(15000);
        }
      );
    });
  }

  openDropdown(e) {
    e.event.stopPropagation();
    // Si se clickeo en el mismo boton del dropdown abierto, cerrarlo.
    if(e.id === this._dropdownConfig.open) {
      this._dropdownConfig.open = '';
      this.dropdown.hide();
      return;
    }

    this._dropdownConfig.open = e.id
    this._dropdownConfig.target = e.event.target;

    // Establecer posicion del dropdown segun el boton que lo haya accionado
    this.setDropdownPosition(e.event.target);

    this.dropdown.show();

    this.getActions(e.id);
  }

  @HostListener('click', ['$event']) onClick(event): void {
    if(event.target !== this.dropdown._elementRef.nativeElement) {
      this._dropdownConfig.open = '';
      this.dropdown.hide();
    }
  }

  @HostListener('window:resize', ['$event']) onResize(event): void {
    this.setDropdownPosition(this._dropdownConfig.target);
  }

   @HostListener('window:keydown.enter', ['$event'])
    handleKeyDown(event: KeyboardEvent) {
    // this.applyFiltersDevice();
  }

  setDropdownPosition(element) {
    if( ! element)
      return;

    element = element.getBoundingClientRect();
    let positionLeft: number = element.left + window.scrollX
    let positionTop: number = element.top + window.scrollY;

    if(positionLeft < 0 && positionTop < 0)
      return;

    this._dropdownConfig.x = positionLeft;
    this._dropdownConfig.y =  positionTop;
  }

  getActions(id) {
    this.actions = null;
    this._gearProxyService.RealTimeDataService.GetDisplayClusterElementActions(
      this._appService.getAccessToken(),
      this._appService.getFacilityID(),
      id,
      success => {
        this.actions = success;
      },
      error => {
        this._appService.showException(error);
      }
    );
  }

  applyFiltersDevice(type?: string, refreshOnChange?: boolean) {
    this.showIcon = 0;
    this.isSearching = false;
    this._filter = '';
    this._subscription.unsubscribe();
    if(!refreshOnChange) {
      this.clustersFullList = [];
      this.filteredClusters = [];
      this.loading = true;
    }
    this._sequenceNumber = 0;
    let values = this.formParam.getFormParameterValues();
    values.forEach((item, i) => {
      if( ! this.formParameterApplied[i])
        this.formParameterApplied.push(new CoreTypes.FormParameter);

      this.formParameterApplied[i].ParameterID = item.ParameterID;
      this.formParameterApplied[i].ParameterType = item.ParameterType;
      this.formParameterApplied[i].ValueDateEnd = item.ValueDateEnd;
      this.formParameterApplied[i].ValueDateStart = item.ValueDateStart;
      this.formParameterApplied[i].ValueMultiString = item.ValueMultiString;
      this.formParameterApplied[i].ValueNumber = item.ValueNumber;
      this.formParameterApplied[i].ValueString = item.ValueString;
      this.formParameterApplied[i].RefreshOnChange = true;
    });
    if (this.formParameterApplied.findIndex(p => p.RefreshOnChange === true) > -1) {
      // this.tokenDevice = '';
      this.getData(refreshOnChange);
    }
    if(!refreshOnChange && !type) {
      this.clustersFullList = [];
      this.filteredClusters = [];
      this._sequenceNumber = 0;
      this.dateLasUpdate = null;
      this.getRecursively();
    }
  }

  applyTextFilter(): void {
    const normalize = (text: string): string =>
      text?.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase() ?? '';
  
    const filter = normalize(this._filter);
  
    if (!filter || filter.length <= 1) {
      this.filteredClusters = [...this.clustersFullList];
      return;
    }
  
    this.filteredClusters = this.clustersFullList
      .map(cluster => {
        const clusterDescriptionMatch = normalize(cluster.Description).includes(filter);
  
        const matchedElements = cluster.Elements?.filter(el => {
          return el.Values?.some(val =>
            normalize(val?.toString()).includes(filter)
          );
        });
  
        if (clusterDescriptionMatch) { return { ...cluster }; }
  
        if (matchedElements?.length > 0) { return { ...cluster, Elements: matchedElements }; }
  
        return null;
      })
      .filter(c => c !== null);
  }
  

  onFilterInput(): void {
    if (this.searchTimeOut) {
      clearTimeout(this.searchTimeOut);
    }
    
    this.isSearching = true;
    this.showTailSpinner = false; 
    this.applyTextFilter();
    
    this.searchTimeOut = setTimeout(() => {
      this.isSearching = false;
    }, 800); 
  }

  clearFilter(): void {
    if (this.searchTimeOut) {
      clearTimeout(this.searchTimeOut);
    }
    
    this._filter = '';
    this.isSearching = false;
    this.applyTextFilter();
  }

  getParametersFromToken(parametersToken: string) {
    this._coreProxyService.ReportingService.GetParametersFromToken(
      parametersToken,
      (data: CoreTypes.FormParameter[]) => {
        this.formParameterList = [];
        data.forEach(item => {
          item.RefreshOnChange = true;
          this.formParameterList.push(item);
        });
        this.formParameterApplied = JSON.parse(JSON.stringify(this.formParameterList));
        this.getRecursively();
        this.tokenDevice = '';
      },
      error => {
        this._appService.showException(error);
      }
    )
  }

  onInputFilter(e?) {
    if (e) {
      const target = (e.originalTarget)
        ? e.originalTarget.parentNode.offsetParent.className
        : (e.target) ? e.target.parentNode.offsetParent.className : null;
      if (target && target === "dropdown-menu ng-star-inserted") { return; }
    }
    window.clearTimeout(this.searchTimeOut);
    this.searchTimeOut = setTimeout(() => this.applyFiltersDevice('onFilter', true), 50);
  }

  appendModal() {
    setTimeout(() => {
      if(!document.getElementsByTagName('app-root')[0].contains(document.getElementById('securityModal')) && document.getElementById('securityModal'))
        document.getElementsByTagName('app-root')[0].appendChild(document.getElementById('securityModal'));
    }, 1000);
  }

  sortCollapseItems(items, type?) {
    switch (type) {
      case "devices":
        items.sort((a, b) => {
          let itemA = a.Description.toUpperCase();
          let itemB = b.Description.toUpperCase();
          return itemA < itemB ? -1 : itemA > itemB ? 1 : 0;
        });
        break;
      case "endpoints":
        items.forEach(x => {
          x.Elements.sort((a, b) => {
            let itemA = a.Values[0].toUpperCase();
            let itemB = b.Values[0].toUpperCase();
            return itemA < itemB ? -1 : itemA > itemB ? 1 : 0;
          });
        })
        break;
    }

  }

  ChangeRefreshParameters(state: boolean) {
    this.formParameterList.forEach((param, i) => {
      if (param.ValueMultiString !== null && state === true &&  param.RefreshOnChange === true) {
        this._appService.onMultiSelectButtonState.next(state);
        this.emitChangeParam();
      }
      if (param.ValueMultiString !== null && state === false && param.RefreshOnChange === true) {
        this._appService.onMultiSelectButtonState.next(state);
        if (JSON.stringify(this._paramSelected) === JSON.stringify(param) && this.formParameterList.findIndex(p => param.ParameterType === 0 || param.ParameterType === 1) < 0) {
          this._sharedCommonService.onRefreshFormParameter.next(true);
        }
      }
    });
  }	
  
  emitChangeParam(param?) {
    this._paramSelected = new CoreTypes.FormParameter();
    this._paramSelected = param;
  }
}
